/**
 * Pensum del taller "De la Idea al Stream: Domina la Radio Visual y otras plataformas"
 */
export const scheduleData = [
  {
    time: '08:00 - 09:30',
    title: '1. El ADN de tu Show',
    subtitle: 'Identidad, nicho y ¿por qué te van a ver?',
    topics: [
      '¿Cómo hacer tu programa interesante?',
      'Tu "Nicho": Menos es más. Es mejor ser el experto en cactus que un opinólogo de todo.',
    ],
    icon: 'dna',
  },
  {
    time: '09:30 - 10:30',
    title: '2. Pre-producción: Construir el mapa del tesoro',
    topics: [
      'La Escaleta: Cómo organizar los temas para no perderse. La planificación de contenido (entrevistados, material de apoyo con recursos visuales y cronograma de trabajo)',
      'El guion técnico vs el guion creativo',
      'Preparando la escena con el "Look & Feel" (Escenografía y toque personal)',
      'Trabajo en imagen personal',
    ],
    icon: 'map',
  },
  {
    time: '10:30 - 11:30',
    title: '3. Producción: llegó el momento de la grabación y/o estamos en vivo',
    topics: [
      '"El lenguaje de la cámara"',
      '¿Cómo hacer realidad lo planificado?',
    ],
    icon: 'broadcast',
  },
  {
    time: '11:30 - 11:45',
    title: 'Receso Café',
    subtitle: '☕ Descanso necesario.',
    topics: [],
    isBreak: true,
    icon: 'coffee',
  },
  {
    time: '11:45 - 12:45',
    title: 'Postproducción. 4. El Eco: Multiplicando tu contenido en RRSS',
    subtitle: 'Clips, Reels y cómo hacer que el programa dure toda la semana.',
    topics: [
      'Aquí es donde la radio visual y otras plataformas se vuelven viral al manejar el concepto del "Contenido Pilar": Un programa de 1 hora = 10 clips para TikTok / Reels / Short / Historias',
      'Recomendaciones de herramientas mágicas: Uso de IA para subtitular y recortar (CapCut, OpusClip y Canva, entre otros).',
    ],
    icon: 'viral',
  },
  {
    time: '12:45 - 13:00',
    title: 'Cierre y Q&A (preguntas y respuestas)',
    subtitle: 'Dudas finales y próximos pasos.',
    topics: [],
    icon: 'closure',
  },
];
